var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamationmark.triangle.fill",
    clipPath: "url(#clip0_144_247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66602 18.5547H17.8027C19.4629 18.5547 20.4688 17.4023 20.4688 15.9082C20.4688 15.4492 20.332 14.9707 20.0879 14.541L12.5098 1.33789C12.002 0.449219 11.1328 0 10.2344 0C9.33594 0 8.45703 0.449219 7.95898 1.33789L0.380859 14.541C0.117188 14.9805 0 15.4492 0 15.9082C0 17.4023 1.00586 18.5547 2.66602 18.5547Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2441 12.0312C9.73633 12.0312 9.45312 11.7383 9.44336 11.2207L9.31641 5.9082C9.30664 5.39062 9.6875 5.01953 10.2344 5.01953C10.7617 5.01953 11.1719 5.40039 11.1621 5.91797L11.0156 11.2207C11.0059 11.748 10.7227 12.0312 10.2441 12.0312ZM10.2441 15.3027C9.6582 15.3027 9.15039 14.834 9.15039 14.2578C9.15039 13.6719 9.64844 13.2031 10.2441 13.2031C10.8301 13.2031 11.3281 13.6621 11.3281 14.2578C11.3281 14.8438 10.8203 15.3027 10.2441 15.3027Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8301,
    height: 18.6621,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.47e909553d10831cce9531fe8deb442b.svg";
export { ForwardRef as ReactComponent };